import React from 'react'
import classNames from 'classnames'

const WelcomeBackMsg = ({ welcomeBackMsgVisible, isOnMobile, loggedInData, closeWelcomeBackMsg }) => {
  const welcomeBackMsgClasses = classNames({
    'welcomeBackMsg': true,
    'popover': !isOnMobile,
    'bottom': !isOnMobile,
    'hidden': !welcomeBackMsgVisible,
    'show': welcomeBackMsgVisible,
    'hidden-xs': !isOnMobile,
    'hidden-sm': isOnMobile,
    'hidden-md': isOnMobile,
    'hidden-lg': isOnMobile
  })

  return (
    <div className={welcomeBackMsgClasses}>
      <div className='arrow' />
      <a href='#' className='popover-dismiss' onClick={closeWelcomeBackMsg} data-hxtrack-name='welcome_message_close_button'>x</a>
      <div className='popover-content'>
        <strong>Welcome back {loggedInData.first_name}</strong><br />
        If there is anything we can do please hit <a href='/help-and-support.html'>Help & Support</a>.<br />
        We really do value your business.
      </div>
    </div>
  )
}

export default WelcomeBackMsg